module.exports = __webpack_public_path__ + "img/logoIcon.00fa25f1.jpg";